export const cloneTr = (tr) => {
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
export const equalNodeType = (nodeType, node) => {
    return (Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1) || node.type === nodeType;
};
//# sourceMappingURL=helper.js.map